function attachRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else if (typeof ref === 'object' && ref !== null) {
        ref.current = node;
    }
}
function combineRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function functionalRef(node) {
        refs.filter(function (ref) { return ref != null; }).forEach(function (ref) { return attachRef(ref, node); });
    };
}
export default combineRefs;
